<template>
  <div class="body-content outer-top-xs" id="top-banner-and-menu">
    <div class="container">
      <div class="row">
        <!-- ============================================== SIDEBAR ============================================== -->
        <SideBar></SideBar>
        <!-- ============================================== SIDEBAR : END ============================================== -->

        <!-- ============================================== CONTENT ============================================== -->
        <div class="col-xs-12 col-sm-12 col-md-9 homebanner-holder" style="text-align: center">
          <!-- ========================================== SECTION – HERO ========================================= -->
          <div id="hero" style="margin-bottom: 20px">
            <div id="owl-main" class="owl-carousel owl-inner-nav owl-ui-sm">
              <div v-for="eachSlide in dataSlider">
                <div class="item" :style="'background-image: url(' + eachSlide.filePath +')'">
                  <!--                  <div class="container-fluid">-->
                  <!--                    <div class="caption bg-color vertical-center text-left">-->
                  <!--                      <div class="slider-header fadeInDown-1">Top Brands</div>-->
                  <!--                      <div class="big-text fadeInDown-1"> New Collections</div>-->
                  <!--                      <div class="excerpt fadeInDown-2 hidden-xs"><span>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</span>-->
                  <!--                      </div>-->
                  <!--                      <div class="button-holder fadeInDown-3">-->
                  <!--                        <a href="index.php?page=single-product"-->
                  <!--                           class="btn-lg btn btn-uppercase btn-primary shop-now-button">Shop Now</a>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!-- /.caption -->
                  <!--                  </div>-->
                  <!-- /.container-fluid -->
                </div>
              </div>
              <!-- /.item -->
            </div>
            <!-- /.owl-carousel -->
          </div>
          <!-- ========================================= SECTION – HERO : END ========================================= -->

          <!-- ============================================== SCROLL TABS ============================================== -->
          <template v-for="eachPro in dataProducts" :key="eachPro.id">
            <div class="scroll-tabs outer-top-vs wow fadeInUp" v-if="eachPro.lsProduct && eachPro.lsProduct.length > 0">
              <div class="more-info-tab clearfix">
                <h3 class="new-product-title pull-left">{{ eachPro.name }}</h3>
              </div>
              <!-- /.nav-tabs -->
              <div class="tab-content outer-top-xs">
                <div class=" tab-pane in active">
                  <div class="product-slider">
                    <div class="owl-carousel home-owl-carousel custom-carousel owl-theme" data-item="4">
                      <template v-for="each in eachPro.lsProduct" :key="each.id">
                        <div class="item item-carousel">
                          <div class="products">
                            <div class="product">
                              <div class="product-image">
                                <div class="image">
                                  <a @click="$router.push(`/product/${encodeURIComponent(each.code)}`)">
                                    <!--                                  <img src="/static/img/flip/products/p2.jpg" alt="">-->
                                    <img style="min-height: 200px; max-height: 200px;" :src="each.image" :alt="each.image">
                                  </a>

                                  <div v-if="each.discount != null && each.discount != 0" class="tag sale"><span>{{each.discount + "%"}}</span></div>
                                </div>
                                <!-- /.image -->
                                <!--                                <div class="tag hot"><span>hot</span></div>-->
                              </div>
                              <!-- /.product-image -->
                              <div class="product-info text-left">
                                <h3 class="name"><a @click="$router.push(`/product/${encodeURIComponent(each.code)}`)">{{ each.name }}</a></h3>
                                <div class="description"></div>
                                <div class="product-price" v-if="each.price != 0">
                                  <span v-if="each.discount != null && each.discount != 0" class="price"> {{$helper.formatPrice(each.price - each.price * each.discount / 100) + "đ"}} </span> 
                                  <span v-if="each.discount != null && each.discount != 0" class="price-before-discount">{{$helper.formatPrice(each.price) + "đ"}}</span>
                                  <span v-if="each.discount == null || each.discount == 0" class="price">{{$helper.formatPrice(each.price) + "đ"}}</span>
                                </div>
                                <div class="product-price" v-else>
                                  <span class="price">Liên hệ</span>
                                </div>

                                <!-- /.product-price -->
                              </div>
                              <!-- /.product-info -->
                            </div>
                            <!-- /.product -->
                          </div>
                          <!-- /.products -->
                        </div>
                      </template>
                      <!-- /.item -->
                    </div>
                    <!-- /.home-owl-carousel -->
                  </div>
                  <!-- /.product-slider -->
                </div>
                <!-- /.tab-pane -->
              </div>
              <!-- /.tab-content -->
            </div>
          </template>
          <!-- /.scroll-tabs -->
          <!-- ============================================== SCROLL TABS : END ============================================== -->
          <div v-show="isShowLoadingData" class="fa fa-spinner fa-spin" style="font-size: 40px;"></div>
        </div>
        <!-- /.homebanner-holder -->
        <!-- ============================================== CONTENT : END ============================================== -->
      </div>
      <!-- /.row -->
      <!-- ============================================== BRANDS CAROUSEL ============================================== -->
      <div id="brands-carousel" class="logo-slider wow fadeInUp">
        <div class="logo-slider-inner">
          <div id="brand-slider" class="owl-carousel brand-slider custom-carousel owl-theme">
            <div class="item m-t-15"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand1.png"
                                                                     src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item m-t-10"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand2.png"
                                                                     src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand3.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand4.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand5.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand6.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand2.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand4.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand1.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->

            <div class="item"><a href="#" class="image"> <img data-echo="/static/img/flip/brands/brand5.png"
                                                              src="/static/img/flip/blank.gif" alt=""> </a></div>
            <!--/.item-->
          </div>
          <!-- /.owl-carousel #logo-slider -->
        </div>
        <!-- /.logo-slider-inner -->

      </div>
      <!-- /.logo-slider -->
      <!-- ============================================== BRANDS CAROUSEL : END ============================================== -->
    </div>
    <!-- /.container -->
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
  <!-- /#top-banner-and-menu -->
</template>

<script>
import BaseFormLoading from './base/BaseFormLoading'
import SideBar from "./SideBar";

export default {
  name: 'Home',
  components: {SideBar, BaseFormLoading},
  data: function () {
    return {
      loading: {
        value: false
      },
      dataSlider: [],
      dataProducts: [],
      isShowLoadingData: false
    }
  },
  computed: {},
  created() {
    this.loadDataSlider();
    this.loadDataProduct();
  },
  mounted() {
    /* Load script */
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', '../../static/js/flip/scripts.js')
    document.head.appendChild(recaptchaScript)
    /* End load script */
  },
  methods: {
    loadDataSlider: function () {
      let that = this;
      this.$helper.loadDataSource({
        // loading: that.loading,
        url: "/slide/listSlideActive",
        successCallback: function (response) {
          that.dataSlider = response.data.data.data;
          setTimeout(function () {
            $('#owl-main').owlCarousel({
              autoPlay: 5000,
              items: 4,
              stopOnHover: true,
              lazyLoad: true,
              navigation: true,
              pagination: true,
              singleItem: true,
              addClassActive: true,
              transitionStyle: "fade",
              navigationText: ["<i class='icon fa fa-angle-left'></i>", "<i class='icon fa fa-angle-right'></i>"],
            });
          })
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    async loadDataProduct() {
      this.isShowLoadingData = true
      let data = await this.processLoadData();
      this.dataProducts = this.uniqueHomeProducts(Array.isArray(data) ? data : [])
      this.$nextTick(() => {
        setTimeout(() => {
          $('.home-owl-carousel').each(function () {
            let owl = $(this);
            if (owl.data('owl-init')) {
              return;
            }
            let itemPerLine = owl.data('item');
            if (!itemPerLine) {
              itemPerLine = 4;
            }
            owl.owlCarousel({
              items: itemPerLine,
              itemsTablet: [768, 2],
              navigation: true,
              pagination: false,
              lazyLoad: true,
              navigationText: ["", ""]
            });
          });
          this.isShowLoadingData = false
        }, 50)
      })
    },
    uniqueHomeProducts(categories) {
      const seenCategory = {}
      const result = []
      for (const category of categories) {
        if (!category || seenCategory[category.id]) {
          continue
        }
        seenCategory[category.id] = true
        const seenProduct = {}
        const products = Array.isArray(category.lsProduct) ? category.lsProduct : []
        category.lsProduct = products.filter(product => {
          if (!product || seenProduct[product.id]) {
            return false
          }
          seenProduct[product.id] = true
          return true
        })
        result.push(category)
      }
      return result
    },
    processLoadData() {
      return new Promise((resolve => {
        let that = this;
        this.$helper.loadDataSource({
          url: "/product/getProductForHome",
          dataSubmit: function () {
            return {}
          },
          successCallback: function (response) {
            resolve(response.data.data)
          },
          errorCallback: function (error) {
            that.isShowLoadingData = false
            resolve([])
            that.$helper.handleError(that.$router, error);
          }
        });
      }))
    }
  },
}
</script>


<style scoped>
  a:hover {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/Home.vue